import React from 'react';
import folderImg from 'images/folder-outline.svg';
import peopleImg from 'images/people-outline.svg';
import './RealTimeNum.css';

const RealTimeNum = () => {
  const realTimeNumProps = {
    projectNum: 1542,
    happyClient: 1136,
  }

  return (
    <div className='iq-img mt-6'>
      <div className='lg:flex justify-center ig-overlay py-5'>
        <div className='flex justify-center combine' style={{flex:1}}>
        </div>
        <div className='flex justify-center combine' style={{flex:1}}>
          <img className='svgFormat' src={folderImg} alt=''></img>
          <div className='text-white text-3xl'>{realTimeNumProps.projectNum}</div>
          <div className='text-white text-xl'>Projects</div>
        </div>
        <div className='flex justify-center combine' style={{flex:1}}>
          <img className='svgFormat' src={peopleImg} alt=''></img>
          <div className='text-white text-3xl'>{realTimeNumProps.happyClient}</div>
          <div className='text-white text-xl'>Happy Clients</div>
        </div>
        <div className='flex justify-center combine' style={{flex:1}}>
        </div>
      </div>

    </div>
  )
}

export default RealTimeNum;